import { Visibility } from "@mui/icons-material";
import { Box, Chip, Link, Typography } from "@mui/material";

import { ScorecardAnalysisData } from "../../../data/queries/coaching";

interface ExampleItemProps {
  item: ScorecardAnalysisData;
  index: number;
  type: "low" | "high";
}

const ExampleItem = ({ item, index, type }: ExampleItemProps) => {
  const isLowScore = type === "low";

  return (
    <Box
      sx={{
        p: 2,
        bgcolor: "background.default",
        borderRadius: 1,
        borderLeft: 3,
        borderColor: isLowScore ? "error.main" : "success.main"
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="caption" color="text.secondary">
            Example {index + 1}
          </Typography>
          {item.interaction_id && (
            <Link
              href={`/viewer?interaction_id=${item.interaction_id}`}
              target="_blank"
              rel="noopener noreferrer"
              sx={{ display: "flex", alignItems: "center", gap: 0.5, fontSize: "0.75rem" }}
            >
              <Visibility sx={{ fontSize: "0.875rem" }} />
              View
            </Link>
          )}
        </Box>
        <Chip
          label={`Score: ${item.score_value.toFixed(2)}`}
          size="small"
          color={isLowScore ? "error" : "success"}
        />
      </Box>
      {item.summary && (
        <Typography variant="body2" sx={{ mb: 1 }}>
          <strong>{isLowScore ? "What happened:" : "What you did well:"}</strong> {item.summary}
        </Typography>
      )}
      {item.score_justification && (
        <Typography variant="body2" sx={isLowScore ? { mb: 1 } : undefined}>
          <strong>{isLowScore ? "Why this score:" : "Why this is good:"}</strong>{" "}
          {item.score_justification}
        </Typography>
      )}
      {isLowScore && item.next_time && (
        <Typography variant="body2" sx={{ color: "primary.main" }}>
          <strong>Next time try:</strong> {item.next_time}
        </Typography>
      )}
    </Box>
  );
};

export default ExampleItem;
